define((require) => {
    "use strict";

    const ImprovedView                  = require("editor/zbone/ImprovedView"),
        template                        = require("ui/editor/email/renderer/EmailRenderer.tpl"),
        MetaData                        = require("ui/editor/email/renderer/EmailMetaData"),
        configuration                   = require("shared/services/Configuration"),
        util                            = require("shared/util/UrlUtil"),
        {arrayFlat, getOpacityCssClass} = require("ui/editor/email/renderer/Utils");

    const TRANSPARENT_IMG_URL = "https://creator.zmags.com/images/transparent.png";

    return ImprovedView.extend({
        tagName: "html",
        attributes: {
            "xmlns": "http://www.w3.org/1999/xhtml",
            "xmlns:o": "urn:schemas-microsoft-com:office:office"
        },
        template,

        templateHelpers() {
            return Object.assign({
                getOpacityCssClass,
                cloudinaryUrl: this._getCloudinaryUrl(),
                util,
                transparentImg: TRANSPARENT_IMG_URL
            }, this.options);
        },

        regions: {
            head: "head"
        },

        onRender() {
            this.head.show(new MetaData(this.renderStyles(this.options.tableJSON)));
        },

        renderStyles(data) {
            const styles = new Set();
            const gmailStyles = new Set();
            const flatData = arrayFlat(data);
            flatData.filter((td) => td.hoverOpacity).forEach(({hoverOpacity})=>{
                gmailStyles.add(`u~div table.gmail_w td.${getOpacityCssClass(hoverOpacity)}:hover{opacity:${hoverOpacity};}`);
                styles.add(`td.${getOpacityCssClass(hoverOpacity)}:hover{filter: contrast(${hoverOpacity / (2 - hoverOpacity)}) brightness(${2 - hoverOpacity});}`);
            });
            const {hoverToggleImage = null} = flatData.find((td) => td.hoverToggleImage) || {};
            if (hoverToggleImage) {
                styles.add(`.rollover:hover img {display:block !important;}`);
            }
            return {
                styles: Array.from(styles).join(""),
                gmailStyles: Array.from(gmailStyles).join("")
            };
        },

        _getCloudinaryUrl() {
            const pattern = new RegExp("^(http|https)://", "i");
            return pattern.test(configuration.cloudinaryProviderUrl)
                ? configuration.cloudinaryProviderUrl
                : `https:${configuration.cloudinaryProviderUrl}`;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/email/renderer/EmailRenderer.js